import {$dom} from "../../helpers/dom";
import Component from "../../classes/Component";
import {$events} from "../../helpers/events";

const {getAll, get} = $dom

const formDisableGroupSelector = '.js-form-disable-group'
const formDisableInputSelector = '.js-form-disable-input'

export default function () {
    const handleDisable = (e) => {
        const inputs = getAll(formDisableInputSelector, e.target.closest(formDisableGroupSelector))

        const allInputsFilled = inputs.every(item => item.value.length > 0)

        get('button[type="submit"]', formDisableGroupSelector).disabled = !allInputsFilled;
    }

    return new Component({
        name: 'disableButton',
        requiredTargets: [formDisableGroupSelector, formDisableInputSelector],
        onInit() {
            $events.delegate.on('input', formDisableInputSelector, handleDisable)
        },
        onDestroy() {
            console.log('disableButton')
        },
    })

}